import { IAdMedium } from "./iad-medium.interface";

export const adSectionData: IAdMedium[] = [
  {
    mediumId: "SOCIAL",
    mediumName: "Social",
    adTypes: [
      {
        adTypeId: "LINK_AD",
        adTypeName: "Link Ad",
        adFormats: [
          {
            adFormatId: "ANIMATED",
            adFormatName: "Animated",
            specifications: "Sizes: 1080 x 1080 or 1080 x 1350\nFile format: MP4",
          },
          {
            adFormatId: "STATIC",
            adFormatName: "Static",
            specifications: "Sizes: 1080 x 1080 or 1080 x 1350\nFile format: PNG",
          },
        ],
      },
      {
        adTypeId: "COLLECTIONS",
        adTypeName: "Collections",
        adFormats: [
          {
            adFormatId: "ANIMATED",
            adFormatName: "Animated",
            specifications: "Size: 1080 x 1080\nFile format: MP4",
          },
          {
            adFormatId: "STATIC",
            adFormatName: "Static",
            specifications: "Size: 1080 x 1080\nFile format: PNG",
          },
        ],
      },
      {
        adTypeId: "CAROUSEL",
        adTypeName: "Carousel",
        adFormats: [
          {
            adFormatId: "ANIMATED",
            adFormatName: "Animated",
            specifications: "Size: 1080 x 1080\nFile format: MP4",
          },
          {
            adFormatId: "STATIC",
            adFormatName: "Static",
            specifications: "Size: 1080 x 1080\nFile format: PNG",
          },
        ],
      },
      {
        adTypeId: "STORY",
        adTypeName: "Story",
        adFormats: [
          {
            adFormatId: "ANIMATED",
            adFormatName: "Animated",
            specifications: "Size: 1080 x 1920\nFile format: MP4",
          },
          {
            adFormatId: "STATIC",
            adFormatName: "Static",
            specifications: "Size: 1080 x 1920\nFile format: PNG",
          },
          {
            adFormatId: "TAP_CAROUSEL",
            adFormatName: "Tap Carousel",
            specifications: "Size: 1080 x 1920\nFile format: MP4",
          },
        ],
      },
    ],
  },
  {
    mediumId: "DISPLAY",
    mediumName: "Display",
    adTypes: [
      {
        adTypeId: "MOBILE_BANNER",
        adTypeName: "Mobile Banner",
        adFormats: [
          {
            adFormatId: "ANIMATED",
            adFormatName: "Animated",
            specifications: "Sizes: 300 x 250, 320 x 480\nFile format: HTML",
          },
          {
            adFormatId: "STATIC",
            adFormatName: "Static",
            specifications: "Sizes: 300 x 250, 320 x 480\nFile format: PNG",
          },
        ],
      },
      {
        adTypeId: "EXPANDABLE_BANNER",
        adTypeName: "Expandable Banner",
        adFormats: [
          {
            adFormatId: "ANIMATED",
            adFormatName: "Animated",
            specifications: "Size: 300 x 250\nExpands to: 1080 x 1920\nFile format: HTML",
          },
          {
            adFormatId: "STATIC",
            adFormatName: "Static",
            specifications: "Size: 300 x 250\nExpands to: 1080 x 1920\nFile format: PNG",
          },
        ],
      },
      {
        adTypeId: "STANDARD_BANNER",
        adTypeName: "Standard Banner",
        adFormats: [
          {
            adFormatId: "ANIMATED",
            adFormatName: "Animated",
            specifications: "Sizes: 300 x 600, 300 x 250, 728 x 90\nFile format: HTML",
          },
          {
            adFormatId: "STATIC",
            adFormatName: "Static",
            specifications: "Sizes: 300 x 600, 300 x 250, 728 x 90\nFile format: PNG",
          },
        ],
      },
      {
        adTypeId: "SPOTIFY_AD",
        adTypeName: "Spotify Ad",
        adFormats: [
          {
            adFormatId: "STATIC",
            adFormatName: "Static",
            specifications: "Size: 640 x 640\nFile format: JPEG",
          },
        ],
      },
      {
        adTypeId: "GMAIL_AD",
        adTypeName: "Gmail Ad",
        adFormats: [
          {
            adFormatId: "STATIC",
            adFormatName: "Static",
            specifications: "Size: 650 x 650\nFile format: PNG",
          },
        ],
      },
      {
        adTypeId: "HPTO",
        adTypeName: "HPTO",
        adFormats: [
          {
            adFormatId: "STATIC",
            adFormatName: "Static",
            specifications: "",
          },
        ],
      },
    ],
  },
  {
    mediumId: "DIGITAL",
    mediumName: "Digital",
    adTypes: [
      {
        adTypeId: "BUMPER",
        adTypeName: "Bumper",
        adFormats: [
          {
            adFormatId: "ANIMATED",
            adFormatName: "Animated",
            specifications: "Size: 1920 x 1080\nFile format: MP4",
          },
        ],
      },
      {
        adTypeId: "TRUEVIEW",
        adTypeName: "Trueview",
        adFormats: [
          {
            adFormatId: "ANIMATED",
            adFormatName: "Animated",
            specifications: "Size: 1920 x 1080\nFile format: MP4",
          },
        ],
      },
    ],
  },
];
